import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { withFormik } from 'formik';
import { object, string } from 'yup';
import isEmpty from 'lodash.isempty';
import { OptionShape, SelectOptionsShape } from 'next/lib/shapes';

import {
  Button,
  ButtonGroup,
  ErrorMsg,
  Input,
  Label,
  Select,
} from 'next/components/ui';
import { Form } from './styled';

export const CreateForm = ({
  errors = {},
  handleBlur,
  handleChange,
  loading,
  onClose,
  onSubmit,
  renderAdditionalFields,
  resetForm,
  setValues,
  tags = [],
  touched = {},
  values = {},
  visible,
}) => {
  useEffect(() => {
    if (visible) resetForm();
  }, [resetForm, visible]);

  const disabled = loading || isEmpty(touched) || !isEmpty(errors);

  const handleAddFieldChange = value => {
    setValues({ ...values, ...value });
  };

  return (
    <Form onSubmit={e => onSubmit(e, values)}>
      <Label>
        Name
        <Input
          error={errors.name && touched.name}
          type="text"
          name="name"
          placeholder="Welcome Tour"
          value={values.name}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {errors.name && touched.name && <ErrorMsg>{errors.name}</ErrorMsg>}
      </Label>
      <Label>
        Build URL
        <Input
          error={errors.previewUrl && touched.previewUrl}
          type="text"
          name="previewUrl"
          placeholder="https://myapp.com"
          value={values.previewUrl}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {errors.previewUrl && touched.previewUrl && (
          <ErrorMsg>{errors.previewUrl}</ErrorMsg>
        )}
      </Label>
      {renderAdditionalFields?.({ onChange: handleAddFieldChange })}
      <Label>
        Tags
        <Select
          error={errors.tagIds && touched.tagIds}
          isClearable
          isMulti
          kind="default"
          name="tags"
          placeholder="Select Tags (Optional)"
          portal
          onChange={selectedTags => {
            setValues({
              ...values,
              tagIds: selectedTags.map(({ value }) => value),
            });
          }}
          options={tags}
        />
      </Label>
      <ButtonGroup right>
        <Button kind="primary" type="submit" disabled={disabled}>
          Create
        </Button>
        <Button kind="secondary" onClick={onClose}>
          Cancel
        </Button>
      </ButtonGroup>
    </Form>
  );
};

const formShape = PropTypes.shape({
  name: PropTypes.string,
  previewUrl: PropTypes.string,
  template: OptionShape,
  theme: OptionShape,
  tagIds: PropTypes.arrayOf(PropTypes.string),
});

CreateForm.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  renderAdditionalFields: PropTypes.func,
  tags: SelectOptionsShape,
  visible: PropTypes.bool,

  // formik

  errors: PropTypes.shape({
    name: PropTypes.string,
    previewUrl: PropTypes.string,
  }),
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  resetForm: PropTypes.func,
  setValues: PropTypes.func,
  touched: PropTypes.shape({
    name: PropTypes.bool,
    previewUrl: PropTypes.bool,
    template: PropTypes.bool,
    themes: PropTypes.bool,
    tags: PropTypes.bool,
  }),
  values: formShape,
};

const baseValidationSchemaShape = {
  name: string().required('Name is required'),
  previewUrl: string()
    .required('Build URL is required')
    .url('Must be a valid URL'),
};

const enhanceForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues = {} }) => ({
    name: '',
    previewUrl: '',
    tagIds: [],
    ...initialValues,
  }),
  validationSchema: ({ validationSchema }) =>
    object().shape({
      ...baseValidationSchemaShape,
      ...validationSchema,
    }),
});

export const CreateExperienceForm = enhanceForm(CreateForm);

export default CreateExperienceForm;
